import { useCallback } from 'react';
import { OrderItem } from './useAvatarOrdering';

export const useJsonOutput = (orderedItems: OrderItem[]) => {
    const generateJsonOutputs = useCallback(() => {
        const topAvatarsOrder: string[] = [];
        const avatarsGroupingData: Record<string, string[]> = {};

        orderedItems.forEach(item => {
            if (item.type === 'avatar') {
                topAvatarsOrder.push(item.avatar!.id);
            } else if (item.type === 'group') {
                topAvatarsOrder.push(item.group!.mainAvatar.id);
                if (item.group!.alternatives.length > 0) {
                    avatarsGroupingData[item.group!.mainAvatar.id] = item.group!.alternatives.map(alt => alt.id);
                }
            }
        });

        return {
            top_avatars: topAvatarsOrder,
            avatars_grouping: avatarsGroupingData,
        };
    }, [orderedItems]);

    const generateJsonOutput = useCallback(
        (type: 'top_avatars' | 'avatars_grouping') => {
            const outputs = generateJsonOutputs();

            switch (type) {
                case 'top_avatars':
                    return JSON.stringify(outputs.top_avatars, null, 2);
                case 'avatars_grouping':
                    return JSON.stringify(outputs.avatars_grouping, null, 2);
                default:
                    return '';
            }
        },
        [generateJsonOutputs]
    );

    return {
        generateJsonOutput,
        generateJsonOutputs,
    };
};
